<template>
  <div class="row px-4">
    <div class="col-12 text-center">
      تنظیم دستـــرسی <span class="text-warning">{{ Data.LevelName }}</span> فــــرم <span class="text-warning">{{ Data.FormAutomationName }}</span>
    </div>
    <div class="col-12 mt-3">
      <div class="row">
        <div class="col-2"></div>
        <div class="col-8" :key="Render">
          <div class="col-12 text-center mt-4">
            <div class="form-control text-center">
              <div class="custom-control custom-switch">
                <small id="LbltblComboGrpId50" class="ml-2"> دسترسی تایید و یا رد درخواست</small>
                <input type="checkbox" class="custom-control-input InputText" id="TaaedRad" v-model="dataAxios.hasAccept" @change="Change" />
                <label class="custom-control-label" for="TaaedRad"> </label>
              </div>
            </div>
          </div>
          <div class="col-12 text-center mt-3">
            <div class="form-control text-center">
              <div class="custom-control custom-switch">
                <small id="LbltblComboGrpId50" class="ml-2"> دسترسی مرجوع کردن درخواست</small>
                <input type="checkbox" class="custom-control-input InputText" id="Reject" v-model="dataAxios.hasReject" @change="Change" />
                <label class="custom-control-label" for="Reject"> </label>
              </div>
            </div>
          </div>
          <div class="col-12 text-center mt-3">
            <div class="form-control text-center">
              <div class="custom-control custom-switch">
                <small id="LbltblComboGrpId50" class="ml-2"> دسترسی انجام دادن درخواست</small>
                <input type="checkbox" class="custom-control-input InputText" id="Marjoe" v-model="dataAxios.hasDo" @change="Change" />
                <label class="custom-control-label" for="Marjoe"> </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-2"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dataAxios: {
        tblWorkFlowId: this.Data.tblWorkFlowId,
        tartib: 1,
        hasAccept: false,
        hasReject: false,
        hasDo: false,
      },
      Render: 0,
    }
  },
  props: ['Data', 'Department'],
  created() {
    this.GetAccess()
  },
  methods: {
    GetAccess() {
      let DataAxios = {
        tblWorkFlowId: this.Data.tblWorkFlowId,
        tartib: this.Data.tartib,
      }
      let DataAxios_SetData = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'WorkflowAccess/GetAccessWorkFlow',
        Token: this.$session.get('Token'),
      }
      DataAxios_SetData.ArryfildValue = DataAxios
      this.$PostData(DataAxios_SetData)
        .then((data) => {
          if (data.status == 'Ok') {
            this.dataAxios = data.data
            this.Render++
          }
        })
        .finally(() => {})
    },
    Change() {
      let DataAxios_SetData = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'WorkflowAccess/SetAccessWorkflow',
        Token: this.$session.get('Token'),
      }
      DataAxios_SetData.ArryfildValue = this.dataAxios
      this.$PostData(DataAxios_SetData)
        .then((data) => {
          if (data.status == 'Ok') {
           this.$toasted.success('دسترسی ها با موفقیت بروز شدند',{ duration:1500})
          }
          else {
           this.$toasted.error(data.msg,{ duration:1500})
          }
        })
        .finally(() => {})
    },
  },
}
</script>
<style scoped></style>
